
$( document ).ready(function() {
  // COLLECTION NAV HOVER IMAGES
//   $('li.list-unstyled.li-sub-mega:eq(0)').hover(function() {
//   $('.sub-mega-menu').addClass('hover-menu');
//   $('.sub-mega-menu').css('background', '#FFFFFF url("https://cdn.shopify.com/s/files/1/0019/0496/7745/files/engagement-rings-opc.jpg?6811401294042173528") center center no-repeat');
//   $('.sub-mega-menu').css('background-size', 'cover');
// });
//   $('li.list-unstyled.li-sub-mega:eq(1)').hover(function() {
//   $('.sub-mega-menu').addClass('hover-menu');
//   $('.sub-mega-menu').css('background', '#FFFFFF url("https://cdn.shopify.com/s/files/1/0019/0496/7745/files/womens-wedding-bands-opc.jpg?13657929236284571830") center center no-repeat');
//   $('.sub-mega-menu').css('background-size', 'cover');
// });
//     $('li.list-unstyled.li-sub-mega:eq(2)').hover(function() {
//   $('.sub-mega-menu').addClass('hover-menu');
//   $('.sub-mega-menu').css('background', '#FFFFFF url("https://cdn.shopify.com/s/files/1/0019/0496/7745/files/vintage-antique-jewelry.jpg?8430815943721219616") center center no-repeat');
//   $('.sub-mega-menu').css('background-size', 'cover');
// });
//    $('li.list-unstyled.li-sub-mega:eq(3)').hover(function() {
//   $('.sub-mega-menu').addClass('hover-menu');
//   $('.sub-mega-menu').css('background', '#FFFFFF url("https://cdn.shopify.com/s/files/1/0019/0496/7745/files/fashion-rings-opc.jpg?6291936032230648621") center center no-repeat');
//   $('.sub-mega-menu').css('background-size', 'cover');
// }); 
//   $('li.list-unstyled.li-sub-mega:eq(4)').hover(function() {
//   $('.sub-mega-menu').addClass('hover-menu');
//   $('.sub-mega-menu').css('background', '#FFFFFF url("https://cdn.shopify.com/s/files/1/0019/0496/7745/files/earrings-opc.jpg?4416598484817113710") center center no-repeat');
//   $('.sub-mega-menu').css('background-size', 'cover');
// }); 
//   $('li.list-unstyled.li-sub-mega:eq(5)').hover(function() {
//   $('.sub-mega-menu').addClass('hover-menu');
//   $('.sub-mega-menu').css('background', '#FFFFFF url("https://cdn.shopify.com/s/files/1/0019/0496/7745/files/necklaces-pendants-opc.jpg?13168356468497039063") center center no-repeat');
//     $('.sub-mega-menu').css('background-size', 'cover');
// });
//   $('li.list-unstyled.li-sub-mega:eq(6)').hover(function () {
//     $('.sub-mega-menu').addClass('hover-menu');
//     $('.sub-mega-menu').css('background', '#FFFFFF url("https://cdn.shopify.com/s/files/1/0019/0496/7745/files/lineage-levys-opc-min.jpg?11954210341336329804") center center no-repeat');
//     $('.sub-mega-menu').css('background-size', 'cover');
//   });
//   $('li.list-unstyled.li-sub-mega:eq(7)').hover(function() {
//   $('.sub-mega-menu').addClass('hover-menu');
//   $('.sub-mega-menu').css('background', '#FFFFFF url("https://cdn.shopify.com/s/files/1/0019/0496/7745/files/bracelets-opc.jpg?12750443106291423573") center center no-repeat');
//     $('.sub-mega-menu').css('background-size', 'cover');
// });
//    $('li.list-unstyled.li-sub-mega:eq(8)').hover(function() {
//   $('.sub-mega-menu').addClass('hover-menu');
//   $('.sub-mega-menu').css('background', '#FFFFFF url("https://cdn.shopify.com/s/files/1/0019/0496/7745/files/pins-brooches-opc.jpg?6036190930841645507") center center no-repeat');
//   $('.sub-mega-menu').css('background-size', 'cover');
// });
// $('li.list-unstyled.li-sub-mega:eq(9)').hover(function () {
//   $('.sub-mega-menu').addClass('hover-menu');
//   $('.sub-mega-menu').css('background', '#FFFFFF url("https://cdn.shopify.com/s/files/1/0019/0496/7745/files/pearls-opc.jpg?5028580942465132498") center center no-repeat');
//   $('.sub-mega-menu').css('background-size', 'cover');
// });
// $('li.list-unstyled.li-sub-mega:eq(10)').hover(function () {
//   $('.sub-mega-menu').addClass('hover-menu');
//   $('.sub-mega-menu').css('background', '#FFFFFF url("https://cdn.shopify.com/s/files/1/0019/0496/7745/files/top-designer-opc.jpg?13906399895465669801") center center no-repeat');
//   $('.sub-mega-menu').css('background-size', 'cover');
// });
// $('li.list-unstyled.li-sub-mega:eq(11)').hover(function () {
//   $('.sub-mega-menu').addClass('hover-menu');
//   $('.sub-mega-menu').css('background', '#FFFFFF url("https://cdn.shopify.com/s/files/1/0019/0496/7745/files/watches-opc.jpg?65986127589813735") center center no-repeat');
//   $('.sub-mega-menu').css('background-size', 'cover');
// });
// $('li.list-unstyled.li-sub-mega:eq(12)').hover(function () {
//   $('.sub-mega-menu').addClass('hover-menu');
//   $('.sub-mega-menu').css('background', '#FFFFFF url("https://cdn.shopify.com/s/files/1/0019/0496/7745/files/mens-wedding-bands-opc.jpg?113235594272990433") center center no-repeat');
//   $('.sub-mega-menu').css('background-size', 'cover');
// });
// $('li.list-unstyled.li-sub-mega:eq(13)').hover(function () {
//   $('.sub-mega-menu').addClass('hover-menu');
//   $('.sub-mega-menu').css('background', '#FFFFFF url("https://cdn.shopify.com/s/files/1/0019/0496/7745/files/really-cool-stuff-opc.jpg?14696655093086791181") center center no-repeat');
//   $('.sub-mega-menu').css('background-size', 'cover');
// });
//   $('li.list-unstyled.li-sub-mega:eq(14)').hover(function () {
//     $('.sub-mega-menu').addClass('hover-menu');
//     $('.sub-mega-menu').css('background', '#FFFFFF url("https://cdn.shopify.com/s/files/1/0019/0496/7745/files/colored-stone-jewlery-opc-min_1.png?v=1575659264") center center no-repeat');
//     $('.sub-mega-menu').css('background-size', 'cover');
//   });
  /* EDUCATION START */
    $('.education-block').hover(function () {
    var blockId = $(this).attr('id');
    $('.education-container').attr('id', 'bg' + blockId);
  });

  /* BIRTHSTONES START */
  $('.birthstone-btn').click(function(){
    $(this).siblings('.birthstone-links').show();
  });


  /*CUSTOM DESIGN & REPAIR START*/
  $('.custom-repair-link').click(function(){
    var linkId = $(this).attr('id');
    var contentId = '#cdr-' + linkId;
    $('.repair-title').css('font-weight', '400');
    $('.repair-p').css('font-weight', '400');
    $(contentId).next().css("font-weight", "600");
    $(contentId).next().next().css("font-weight", "600");
  });

  /* ADD CONTAINER TO HOME INSTAGRAM FEED */
  $('.home-instagram').addClass('container');
  

  $('.owl-item>a').hover(function() {
    $('.owl-hover-overlay').fadeIn("fast", function () {
    });
  });

  /* BIO PAGE READ MORE */ 
  $('.read-more').click(function() {
    $(this).siblings('.show-more').show();
    $(this).parent('.bio-wrapper').css('height', '2800px');
    $(this).css('display', 'none');
  });
  $('.read-more-joseph').click(function() {
    $(this).siblings('.show-more').show();
    $(this).parent('.bio-wrapper').css('height', '700px');
    $(this).css('display', 'none');
  });

  /* COLLECTION FILTER START */
  var currentUrl = window.location.pathname.toString().slice(13).replace('-',' ');
  var filterCollection = $('.filter-category-wrapper a h6').text();
  
  $('.filter-dropdown').click(function () {
    var dropDownIcon = $(this);
    var dropDown = $(this).siblings('.filter-dropdown-wrapper');
    dropDown.slideToggle('medium');
    dropDown.toggleClass('open-dropdown');

    if(dropDown.hasClass('open-dropdown')){
      dropDownIcon.removeClass('fa-plus');
      dropDownIcon.addClass('fa-minus');
    } else { !dropDown.hasClass('open-dropdown')
      dropDownIcon.addClass('fa-plus');
      dropDownIcon.removeClass('fa-minus');
    }
  });

  $('.mobile-filter-title').click(function(){
    var mFilter = $('.mobile-filter-container')
    mFilter.slideToggle('medium');
    mFilter.toggleClass('open-dropdown');

    if(mFilter.hasClass('open-dropdown')){
      $('#filter-mobile-drop').removeClass('fa-chevron-down');
      $('#filter-mobile-drop').addClass('fa-chevron-up');
    } else { !mFilter.hasClass('open-dropdown')
      $('#filter-mobile-drop').addClass('fa-chevron-down');
      $('#filter-mobile-drop').removeClass('fa-chevron-up');
    }
  });



  /* collection 'sort by' filter behavior */
  $(window).on('load', function () {
    var url = window.location.href; // Returns full URL
    var sortBy; 
    if (url.includes('manual')) sortBy = 'Featured';
    if (url.includes('ascending')) sortBy = 'Price: Low to High';
    if (url.includes('descending')) sortBy = 'Price: High to Low';
    sortBy = sortBy || 'Featured';
    $('#sort-placeholder').text(sortBy);
    $('li.sortBy').show();
  });


  /* add alt tags to generated images */
  var i = 0;
  $('.logo a img.pulse').each(function(){
    i++;
    var brandId="brand "+ i;
    $(this).attr('alt', brandId);
    $(this).val(i);
  });

  $('.bio-wrapper > img').each(function(){
    i++;
    var teamId = "team img " + i;
    $(this).attr('alt' + i);
    $(this).val(i);
  });

    $('.container_item img').each(function(){
      i++;
      var placeholder = 'image placeholder ' + i;
      var source = $(this).attr('src');
       // console.log(source);
      if (source.indexOf('no-image') >= 0){
        $(this).attr('alt', placeholder);
      }
  });

  // Allow dropdown only links on nav

$('.nav-item:nth-of-type(3) a.dropdown-link')
.attr('href', 'javascript:');

$('.nav-item:nth-of-type(4) a.dropdown-link')
.attr('href', 'javascript:');

// $('.dropdown-menu li a').attr('href', 'initial');

// ALLOW PRODUCT IMAGE ZOOM
$(document).ready(function(){
  $('.product-img')
    .wrap('<span style="display:inline-block"></span>')
    .css('display', 'block')
    .parent() 
    .zoom();
});

// HIDE SOLD OUT PRODUCTS
// if ($('.product-price span').text('sold out')){
//   console.log('sold out true');
// }

// $('.product-price span').each(function (index){
//   // if ($(this).text() == 'sold out') {
//   //   console.log('sold out true')
//   // }
//   // console.log($(this).text())
//   if ($(this).text() == 'Sold Out'){ 
//     $(this).closest('.element').hide();
//     // console.log('one is sold out')
//   } else {
//     // console.log('sold out false')
//   }
// })

// add message to all men's wedding bands

  // if ($('#page-header h1').text().indexOf("Men's" && "Bands") >= 0) {
  //   $("<br><br><div style='display: flex; justify-content: space-evenlt;'><a target='_blank' href='/pages/benchmark-mens-wedding-rings'> <img style='width: 70%' src='https://cdn.shopify.com/s/files/1/0019/0496/7745/files/benchmark-logo-min.png?1230' > </a><br><a target='_blank' href='/pages/benchmark-wedding-bands-forge-collection#grid/brandFilter=Forge'> <img style='width: 35%' src='https://cdn.shopify.com/s/files/1/0019/0496/7745/files/forge-logo-min.png?1240' > </a><br><a target='_blank' href='/pages/benchmark-wedding-rings-tantalum-collection#grid/brandFilter=Tantalum'> <img style='width: 35%' src='https://cdn.shopify.com/s/files/1/0019/0496/7745/files/tantalum-logo-min.png?1240' > </a></div>").appendTo('#page-header h1');
  // }

  // if ($('#page-header h1').text().indexOf("Men's" && "Bands") >= 0) {
  //   $("<br><a href='/pages/benchmark-mens-wedding-rings'>Benchmark Men's Wedding Bands</a>).appendTo('#page-header h1'");
  // }

  // $('.blog-carousel').slick();

  /* product inquiry hack */ 

  // function testHere() {
  //   // var test = $('#KySCcbIwsdMoOTJudKJwFg').children('form-control');
  //   // test.text('something here');
  //   // console.log(test);

  //   // $('.formElement_0 label').text('change to this');
  //   // if ($('.formElement_0')){
  //   //   $('.formElement_0').hide();
  //   //   console.log('should be working');
  //   // } else {
  //   //   console.log('not working');
  //   // }
  // }

  // if ($('#KySCcbIwsdMoOTJudKJwFg')) {
  //   console.log('form exists');
  // } else {
  //   console.log('form broke');
  // }
  // setTimeout(testHere, 5000);
  


}); /* doc ready end */
